export const localesProfileTax: string[] = [
    'LL_PopUp_WaWi_ValdierungInfo_S1_H1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S1_H2_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C2_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C3_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B2_DE',

    'LL_PopUp_WaWi_ValdierungInfo_S3_H1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S3_H2_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C2_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C3_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S3_B1_DE',

    'LL_PopUp_WaWi_ValdierungInfo_S5_H1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S5_H2_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C2_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S5_B1_DE',

    'LL_PopUp_WaWi_ValdierungInfo_S6_H1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S6_H2_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S6_C1_DE',
    'LL_PopUp_WaWi_ValdierungInfo_S6_B1_DE',

    'LL_PopUp_WaWi_ValdierungInfo_S1_H1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_H2_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C2_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C3_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B2_EU',

    'LL_PopUp_WaWi_ValdierungInfo_S3_H1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_H2_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C2_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C3_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_B1_EU',

    'LL_PopUp_WaWi_ValdierungInfo_S5_H1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_H2_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C2_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_B1_EU',

    'LL_PopUp_WaWi_ValdierungInfo_S6_H1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S6_H2_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S6_C1_EU',
    'LL_PopUp_WaWi_ValdierungInfo_S6_B1_EU',

    'LL_PopUp_WaWi_ValdierungInfo_S1_H1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S1_H2_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C2_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C3_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B2_CH',

    'LL_PopUp_WaWi_ValdierungInfo_S3_H1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S3_H2_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C2_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C3_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S3_B1_CH',

    'LL_PopUp_WaWi_ValdierungInfo_S5_H1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S5_H2_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C2_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S5_B1_CH',

    'LL_PopUp_WaWi_ValdierungInfo_S6_H1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S6_H2_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S6_C1_CH',
    'LL_PopUp_WaWi_ValdierungInfo_S6_B1_CH',

    'LL_PopUp_WaWi_ValdierungInfo_S1_H1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S1_H2_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C2_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C3_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B2_FR',

    'LL_PopUp_WaWi_ValdierungInfo_S3_H1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S3_H2_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C2_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C3_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S3_B1_FR',

    'LL_PopUp_WaWi_ValdierungInfo_S5_H1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S5_H2_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C2_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S5_B1_FR',

    'LL_PopUp_WaWi_ValdierungInfo_S6_H1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S6_H2_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S6_C1_FR',
    'LL_PopUp_WaWi_ValdierungInfo_S6_B1_FR',

    'LL_PopUp_WaWi_ValdierungInfo_S1_H1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S1_H2_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C2_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C3_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B2_ES',

    'LL_PopUp_WaWi_ValdierungInfo_S3_H1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S3_H2_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C2_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C3_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S3_B1_ES',

    'LL_PopUp_WaWi_ValdierungInfo_S5_H1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S5_H2_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C2_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S5_B1_ES',

    'LL_PopUp_WaWi_ValdierungInfo_S6_H1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S6_H2_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S6_C1_ES',
    'LL_PopUp_WaWi_ValdierungInfo_S6_B1_ES',

    'LL_PopUp_WaWi_ValdierungInfo_S1_H1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_H2_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C2_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_C3_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S1_B2_nonEU',

    'LL_PopUp_WaWi_ValdierungInfo_S3_H1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_H2_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C2_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_C3_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S3_B1_nonEU',

    'LL_PopUp_WaWi_ValdierungInfo_S5_H1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_H2_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_C2_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S5_B1_nonEU',

    'LL_PopUp_WaWi_ValdierungInfo_S6_H1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S6_H2_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S6_C1_nonEU',
    'LL_PopUp_WaWi_ValdierungInfo_S6_B1_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_InfoBox_Ausstehend_DE',
    'LL_Profil_WaWi_Valdierung_Button_Rechnungs_Lieferadresse_DE',
    'LL_Profil_WaWi_Valdierung_S1_H1_DE',
    'LL_Profil_WaWi_Valdierung_S1_C1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_C1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_B1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C2_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C3_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C4_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_B2_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C2_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C3_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C4_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B2_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_C_B1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_C_C1_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_C_C2_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_C_C3_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_C_C4_DE',
    'LL_Profil_WaWi_Valdierung_S1_Option_C_B2_DE',
    'LL_Profil_WaWi_Valdierung_S1_B3_DE',
    'LL_Profil_WaWi_Valdierung_S3_H1_DE',
    'LL_Profil_WaWi_Valdierung_S3_C1_DE',
    'LL_Profil_WaWi_Valdierung_S5_H1_DE',
    'LL_Profil_WaWi_Valdierung_S5_C1_DE',
    'LL_Profil_WaWi_Valdierung_S5_C2_DE',
    'LL_Profil_WaWi_Valdierung_S5_B1_DE',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_H1_DE',
    'LL_Profil_WaWi_Valdierung_S6_Success_Profile_DE',
    'LL_Profil_WaWi_Valdierung_S6_Success_Profile_FR',
    'LL_Profil_WaWi_Valdierung_S6_Success_Profile_CH',
    'LL_Profil_WaWi_Valdierung_S6_Success_Profile_EU',
    'LL_Profil_WaWi_Valdierung_S6_Success_Profile_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_Success_Profile_ES',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C2_DE',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_H1_DE',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C1_DE',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C2_DE',
    'LL_Profil_WaWi_Valdierung_S6_Option_C_H1_DE',
    'LL_Profil_WaWi_Valdierung_S6_Option_C_C1_DE',
    'LL_Profil_WaWi_Valdierung_S6_Option_C_C2_DE',
    'LL_Profil_WaWi_Valdierung_S6_C1_DE',
    'LL_Profil_WaWi_Valdierung_S6_B1_DE',
    'LL_Profil_WaWi_Valdierung_S6_C2_DE',
    'LL_Profil_WaWi_Valdierung_S6_B2_DE',
    'LL_Profil_WaWi_Valdierung_S6_B3_DE',
    'LL_Profil_WaWi_Valdierung_Header_Rechnungs_Lieferadresse_DE',

    'LL_Profil_WaWi_Valdierung_S1_InfoBox_Ausstehend_EU',
    'LL_Profil_WaWi_Valdierung_Button_Rechnungs_Lieferadresse_EU',
    'LL_Profil_WaWi_Valdierung_S1_H1_EU',
    'LL_Profil_WaWi_Valdierung_S1_C1_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_C1_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_B1_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C1_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C2_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C3_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C4_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_B3_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_Warnung_Info_1_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_Warnung_Link_Text_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_Warnung_Link_URL_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B1_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C1_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C2_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C3_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C4_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B2_EU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B3_EU',
    'LL_Profil_WaWi_Valdierung_S3_H1_EU',
    'LL_Profil_WaWi_Valdierung_S3_C1_EU',
    'LL_Profil_WaWi_Valdierung_S5_H1_EU',
    'LL_Profil_WaWi_Valdierung_S5_C1_EU',
    'LL_Profil_WaWi_Valdierung_S5_C2_EU',
    'LL_Profil_WaWi_Valdierung_S5_B1_EU',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_H1_EU',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C1_EU',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C2_EU',
    'LL_Profil_WaWi_Valdierung_S6_C1_EU',
    'LL_Profil_WaWi_Valdierung_S6_B1_EU',
    'LL_Profil_WaWi_Valdierung_S6_C2_EU',
    'LL_Profil_WaWi_Valdierung_S6_B2_EU',
    'LL_Profil_WaWi_Valdierung_S6_B3_EU',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_H1_EU',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C1_EU',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C2_EU',
    'LL_Profil_WaWi_Valdierung_Header_Rechnungs_Lieferadresse_EU',

    'LL_Profil_WaWi_Valdierung_S1_InfoBox_Ausstehend_nonEU',
    'LL_Profil_WaWi_Valdierung_Button_Rechnungs_Lieferadresse_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_H1_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_C1_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_C1_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B1_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C1_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C2_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C3_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C4_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B2_nonEU',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B3_nonEU',
    'LL_Profil_WaWi_Valdierung_S3_H1_nonEU',
    'LL_Profil_WaWi_Valdierung_S3_C1_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_C1_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_B1_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_B2_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_B3_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_H1_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C1_nonEU',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C2_nonEU',
    'LL_Profil_WaWi_Valdierung_Header_Rechnungs_Lieferadresse_nonEU',

    'LL_Profil_WaWi_Valdierung_S1_InfoBox_Ausstehend_CH',
    'LL_Profil_WaWi_Valdierung_Button_Rechnungs_Lieferadresse_CH',
    'LL_Profil_WaWi_Valdierung_S1_H1_CH',
    'LL_Profil_WaWi_Valdierung_S1_C1_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_C1_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B1_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C1_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C2_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C3_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C4_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B2_CH',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B3_CH',
    'LL_Profil_WaWi_Valdierung_S3_H1_CH',
    'LL_Profil_WaWi_Valdierung_S3_C1_CH',
    'LL_Profil_WaWi_Valdierung_S6_C1_CH',
    'LL_Profil_WaWi_Valdierung_S6_B1_CH',
    'LL_Profil_WaWi_Valdierung_S6_C2_CH',
    'LL_Profil_WaWi_Valdierung_S6_B2_CH',
    'LL_Profil_WaWi_Valdierung_S6_B3_CH',
    'LL_Profil_WaWi_Valdierung_S6_B2_CH',
    'LL_Profil_WaWi_Valdierung_S6_B3_CH',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_H1_CH',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C1_CH',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C2_CH',
    'LL_Profil_WaWi_Valdierung_Header_Rechnungs_Lieferadresse_CH',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C1_DE',
    'LL_Profil_WaWi_Valdierung_S6_C2_ES',
    'LL_Profil_WaWi_Valdierung_S6_C2_nonEU',

    'LL_Profil_WaWi_Valdierung_S1_InfoBox_Ausstehend_ES',
    'LL_Profil_WaWi_Valdierung_Button_Rechnungs_Lieferadresse_ES',
    'LL_Profil_WaWi_Valdierung_S1_H1_ES',
    'LL_Profil_WaWi_Valdierung_S1_C1_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_C1_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_B1_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B1_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B2_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C1_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C2_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C3_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C4_ES',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B3_ES',
    'LL_Profil_WaWi_Valdierung_S3_H1_ES',
    'LL_Profil_WaWi_Valdierung_S3_C1_ES',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_H1_ES',
    'LL_Profil_WaWi_Valdierung_S6_B2_ES',
    'LL_Profil_WaWi_Valdierung_S6_B3_ES',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C1_ES',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C2_ES',
    'LL_Profil_WaWi_Valdierung_S6_C1_ES',
    'LL_Profil_WaWi_Valdierung_S6_B1_ES',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_H1_ES',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C1_ES',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C2_ES',
    'LL_Profil_WaWi_Valdierung_S1_InfoBox_Ausstehend_FR',
    'LL_Profil_WaWi_Valdierung_Button_Rechnungs_Lieferadresse_FR',
    'LL_Profil_WaWi_Valdierung_S1_H1_FR',
    'LL_Profil_WaWi_Valdierung_S1_C1_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_C1_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_B1_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B1_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B2_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C1_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C2_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C3_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_C4_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_B_B3_FR',
    'LL_Profil_WaWi_Valdierung_S3_H1_FR',
    'LL_Profil_WaWi_Valdierung_S6_B2_FR',
    'LL_Profil_WaWi_Valdierung_S6_B3_FR',
    'LL_Profil_WaWi_Valdierung_S3_C1_FR',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_H1_FR',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C1_FR',
    'LL_Profil_WaWi_Valdierung_S6_Option_A_C2_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C1_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C2_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C3_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_C4_FR',
    'LL_Profil_WaWi_Valdierung_S1_Option_A_B3_FR',
    'LL_Profil_WaWi_Valdierung_S6_C1_FR',
    'LL_Profil_WaWi_Valdierung_S6_B1_FR',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_H1_FR',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C1_FR',
    'LL_Profil_WaWi_Valdierung_S6_Option_B_C2_FR',
    'LL_Profil_WaWi_Valdierung_Header_Rechnungs_Lieferadresse_FR',
    'LL_Profil_WaWi_Valdierung_S6_C2_FR',
];
